/**
 * @module glob
 * @since 2.0.0
 * @description The current runtime's global object (`self`/`global`/`window`).
 *
 * @example import {glob} from @fiverr/futile
 * if ('fetch' in glob) { ... }
 */
export const glob =
    (typeof window === 'object' && window.window === window && window)
    ||
    (typeof global === 'object' && global.global === global && global)
    ||
    (typeof self === 'object' && self.self === self && self)
;
